var Coria = Coria || {};

if (!Coria.WaitForjQuery) {
    Coria.WaitForjQueryCounter = 0;
    Coria.WaitForjQuery = function (callback) {
        if (window.jQuery) {
            callback();
        } else if (Coria.WaitForjQueryCounter++ > 50) {
            console.error("Coria.WaitForjQuery: jQuery not present.");
        } else {
            setTimeout(Coria.WaitForjQuery, 250, callback);
        }
    };
}

(function () {
    function openCTALink(isNewWindow, linkUrl) {
        if (isNewWindow == "true")
            window.open(linkUrl);
        else
            location.href = linkUrl;
    }

    function initClickHandlers() {
        // clicking on tile
        jQuery('.hero a').off('click').on('click', buttonClickHandler);
    }

    function buttonClickHandler(event) {
        var goals = jQuery(this).data('goalsToTrigger');
        console.log(goals);
        triggerGoals(goals);
    }

    function setHeroBannerHandlers() {
        Coria.WaitForjQuery(function () {
            jQuery(document).ready(function () {
                initClickHandlers();
                homeHeroAnimation();
            });
        });
    }

    function triggerGoals(goalsArr) {
        if (goalsArr && goalsArr.length) {
            triggerGoal(goalsArr);
        }
    }

    function triggerGoal(goalsArr) {
        makeAjaxCallJQuery("api/sitecore/Analytics/TriggerGoal", { goalId: goalsArr[0] }, function (rsp) {

            goalsArr.shift();

            if (goalsArr && goalsArr.length) {
                triggerGoal(goalsArr);
            }

        }, true);
    }

    function makeAjaxCallJQuery(methodUrl, dataObj, successFun, isAsync) {
        return jQuery.ajax({
            type: 'POST',
            url: methodUrl,
            data: dataObj,
            success: function (responseData, textStatus, jqXHR) {
                successFun(responseData);
            },
            async: isAsync,
            error: function (responseData, textStatus, errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    function homeHeroAnimation() {
        //tdt home hero animation
        if (document.getElementById('challenge-tdt-hero') && window.location.href.indexOf('ed=1') < 0) {
            var elmH = (document.getElementById('challenge-tdt-hero').offsetHeight) * 0.6;
            window.addEventListener('scroll', function (e) {
                var t = window.pageYOffset;

                if (t >= elmH) { return; }
                var heroMain = document.getElementById('hero-img');
                var heroCell0 = document.getElementById('animate-0');
                var heroCell1 = document.getElementById('animate-1');
                var heroCell2 = document.getElementById('animate-2');

                heroMain.style.opacity = Math.abs(elmH - t) * 1.1 / elmH;
                heroMain.style.marginTop = t * 200 / elmH + 'px';

                heroCell0.style.opacity = Math.abs(elmH - t) * 1.2 / elmH;
                heroCell0.style.marginLeft = -t * 100 / elmH + 'px';
                heroCell0.style.marginTop = t * 200 / elmH + 'px';

                heroCell1.style.opacity = Math.abs(elmH - t) / elmH;
                heroCell1.style.marginLeft = -t * 100 / elmH + 'px';
                heroCell1.style.marginTop = t * 20 / elmH + 'px';

                heroCell2.style.opacity = Math.abs(elmH - t) / elmH;
                heroCell2.style.marginLeft = t * 150 / elmH + 'px';
                heroCell2.style.marginTop = t * 10 / elmH + 'px';

                console.log('tdt hero working');
            });
        }
    }

    setHeroBannerHandlers();
})();

